import { Component, Input, OnInit } from "@angular/core";
import Course from "../../models/course.model";
import LectureContent from "../../models/lecture-content.model";

@Component({
  selector: "ngx-view-course-content",
  styleUrls: ["./view-course-content.component.scss"],
  templateUrl: "./view-course-content.component.html",
})
export class ViewCourseContentComponent implements OnInit {
  @Input() course = new Course();
  @Input() lecture: LectureContent = new LectureContent();

  loading = false;
  submitted = false;
  view = "question";

  constructor() {}

  ngOnInit() {
    console.log("ViewCourseContentComponent", this.lecture);
  }

  reply() {
    this.view = "replies";
    console.log("ViewCourseContentComponent/comment", this.lecture);
  }

  closeReply() {
    this.view = "main";
  }
}
